var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-row',{staticClass:"justify-content-end mb-4"},_vm._l((_vm.totals),function(total,index){return _c('d-col',{key:index,attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(_vm.labels[index]))]),_c('d-card',{staticClass:"px-3 py-5"},[_c('h5',{staticClass:"text-right font-weight-bold m-0"},[_vm._v(_vm._s(total))])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }